import * as React from 'react';
import { PageProps } from 'gatsby';
import Layout from '../components/Layout';
import { OhmsLawComponent } from '../components/Equations/OhmsLawComponent';
import { EquationContainer } from '../components/Equations/EquationContainer';

export default function OhmsLawPage(props: PageProps): JSX.Element {
  const pageTitle = 'Ohms Law';

  return (
    <Layout location={props.location} title={pageTitle}>
      <EquationContainer>
        <OhmsLawComponent />
      </EquationContainer>
    </Layout>
  );
}
